import * as FC from "@fluentui/react-components";

export const useCommonStyles = FC.makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        ...FC.shorthands.flex(1),
        ...FC.shorthands.gap("10px"),
        ...FC.shorthands.padding("10px"),
    },
    form: {
        display: "flex",
        flexDirection: "column",
        ...FC.shorthands.gap("10px"),
    },
    row: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        ...FC.shorthands.gap("10px"),
    },
});
